import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getIdKegiatan,
    getListKegiatan,
} from "../../redux/actions/actionKegiatan";
import { AiOutlineUser, AiOutlineSchedule } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

function DetailKegiatan() {
    const [judul, setJudul] = useState();
    const [imgk, setImgk] = useState();
    const [deskripsi, setDeskripsi] = useState();
    const [datek, setDatek] = useState();
    const [user, setUser] = useState();
    const [timek, setTimek] = useState();

    const {
        getIdKegiatanResult,
        getListKegiatanResult,
        getListKegiatanLoading,
        getListKegiatanError,
    } = useSelector((state) => state.indexReducerKegiatan);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListKegiatan());
    }, [dispatch]);

    useEffect(() => {
        if (getIdKegiatanResult) {
            setJudul(getIdKegiatanResult.judul_kegiatan);
            setImgk(getIdKegiatanResult.img_url);
            setDeskripsi(getIdKegiatanResult.deskripsi);
            setDatek(getIdKegiatanResult.createAt);
            setUser(getIdKegiatanResult.user);
            setTimek(getIdKegiatanResult.createTime);
        }
    }, [getIdKegiatanResult]);

    const navigate = useNavigate();
    const handleDetail = (idk) => {
        navigate(`/Kegiatan/${idk.judul_kegiatan.replace(/ /g, "-")}`);
        dispatch(getIdKegiatan(idk));
    };

    return (
        <>
            <div className="detail-kegiatan my-5">
                <div className="row">
                    <div className="content-kegiatan col-lg-7 col-md-7 offset-lg-1 offset-md-1">
                        <div className="body-title mb-2">
                            <h3>{judul}</h3>
                            <div className="title-date d-flex">
                                <li className="d-flex mr-2">
                                    <AiOutlineSchedule />
                                    <p className="mx-1">
                                        {datek} : {timek}
                                    </p>
                                </li>

                                <li className="d-flex mx-2">
                                    <AiOutlineUser size={14} />
                                    <p className="mx-1">{user}</p>
                                </li>
                            </div>
                        </div>
                        <div className="body-img mb-4">
                            <img src={imgk} className="img-fluid" alt="" />
                        </div>
                        <div className="body-deskripsi mb-4">
                            <p>{deskripsi}</p>
                        </div>
                    </div>
                    <div className="sidebar-kegiatan col-lg-3 col-md-3 offset-lg-1 offset-md-1 ">
                        <div className="sidebar-kegiatan-header mb-4">
                            <h5>Relate Topic</h5>
                        </div>
                        <div className="sidebar-kegiatan-content d-block">
                            {getListKegiatanResult ? (
                                <>
                                    {getListKegiatanResult
                                        .slice(0, 5)
                                        .map((item, index) => {
                                            return (
                                                <div
                                                    className="list-content border-bottom mb-3"
                                                    key={index}
                                                >
                                                    <div className="row ">
                                                        <div className="d-flex ">
                                                            <div className="col-lg-3 img-div">
                                                                <img
                                                                    src={
                                                                        item.img_url
                                                                    }
                                                                    width="50"
                                                                    height="50"
                                                                    className="img-fluid sidebar-img"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-lg-9  mx-2 ">
                                                                <Typography
                                                                    className="text-dark sidebar-title cursor-pointer "
                                                                    onClick={() => {
                                                                        handleDetail(
                                                                            item
                                                                        );
                                                                    }}
                                                                >
                                                                    {
                                                                        item.judul_kegiatan
                                                                    }
                                                                </Typography>

                                                                <p>
                                                                    {
                                                                        item.createAt
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </>
                            ) : getListKegiatanLoading ? (
                                <p>Loading Data</p>
                            ) : (
                                <p>
                                    {getListKegiatanError
                                        ? getListKegiatanLoading
                                        : "Data Loading ..."}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DetailKegiatan;
